import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

export function getSingleColumnModule(
  match,
  request,
  classDescription,
  hasSpecialValue
) {
  return `
        <div class="
            justify-between
            flex flex-wrap flex-row 
            singleColumnModule 
            bg-black/20
            text-white
            duration-300
            ease-in-out
            text-[11px]
            px-1
            py-[1px]
            cursor-pointer
            border-r
            border-[#3d3d3d]
            hover:bg-[#8d741d]
            mb-[1px]
            bettingBtn
            ${
              match.nr_of_columns == "1" ? "fullWidthColumn" : classDescription
            } 
            ${match.id}${hasSpecialValue ? "-span" : ``} 
            ${match.id}-coef"
            match-code="${match.game_code || "-"}" 
            match-market-option="${match.market_option}" 
            match-market="${match.market}"
            match-home-name="${match.home_team}"
            match-away-name="${match.away_team}"
            match-odd="${Utils.formatNumber(match.odd)}"
            game-id="${request.id}"
            bet-id="${match.id}"
        >
            ${getInsideSingleColumn(
              match.market_option,
              match.odd,
              match.special_value,
              hasSpecialValue
            )}
        </div>
    `;
}

export function getInsideSingleColumn(
  market_option,
  odd,
  special_value,
  hasSpecialValue
) {
  return `${
    hasSpecialValue
      ? ""
      : `<span class="flex-1 text-white truncate whitespace-nowrap overflow-hidden text-ellipsis max-w-[calc(100%-40px)]">${_t(
          market_option
        )}</span>`
  }<span class="font-bold">${Utils.formatNumber(odd)}</span>`;
}
